import { L10n } from '../L10n/L10n';
import { RunFlowTaskInfo } from '../models/RunFlowTaskInfo';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { RunFlowTasks } from '../resources/RunFlowTasks';
import { AbstractContentAction } from './AbstractContentAction';
import { ConfirmActionDialog, IConfirmActionDialogOptions } from './ConfirmActionDialog';
import { ContentActionNotification, INotificationTranslationIds } from './ContentActionNotification';

export class RunFlowTasksAction extends AbstractContentAction<RunFlowTaskInfo> {

  public static $inject = [
    '$translate',
    'ConfirmActionDialog',
    'ContentActionNotification',
    'RunFlowTasks'
  ];

  constructor(
    private $translate: ng.translate.ITranslateService,
    ConfirmActionDialog: ConfirmActionDialog,
    ContentActionNotification: ContentActionNotification,
    private RunFlowTasks: RunFlowTasks,
  ) {
    super(ConfirmActionDialog, ContentActionNotification);
  }

  configureDialog(dialogConfig: IConfirmActionDialogOptions, runFlowTaskInfos: Set<RunFlowTaskInfo>) {
    const taskCount = runFlowTaskInfos.size();
    if (taskCount === 1) {
      const task = runFlowTaskInfos.first();
      dialogConfig.bodyText = this.$translate.instant('runFlowTaskRunPrompt', {
        FLOW_NAME: L10n.elideIfLong(task.flow.name)
      });
    } else {
      dialogConfig.bodyText = this.$translate.instant('runFlowTasksRunPrompt', {
        ITEM_COUNT: taskCount
      }, L10n.Interpolations.Count);
    }
    dialogConfig.title = this.$translate.instant('runNow');
    dialogConfig.actionName = this.$translate.instant('runNowConfirmButton', {
      ITEM_COUNT: taskCount
    }, L10n.Interpolations.Count);
    dialogConfig.action = () => this.RunFlowTasks.run(runFlowTaskInfos.keys());
  }

  notificationTranslationIds(): INotificationTranslationIds {
    return {
      successId: 'runFlowTasksRunSuccess',
      errorId: 'runFlowTasksRunError'
    };
  }

}

Module.instance().service('RunFlowTasksAction', RunFlowTasksAction);
